export default __webpack_public_path__ + "assets/cd58bdcf42dc1f97d251af8165e5bfe8.woff";